import { computed, Injectable } from '@angular/core';
import { StateValidator } from '../interfaces/state-validator';
import { Store } from '@ngrx/store';
import { AppState } from '../store';
import { Violation } from '../models/violation';
import { ConstraintTypeEnum } from '../enum/constraint-type.enum';
import { ValidationMode } from '../enum/validation-mode.enum';
import { selectInsuranceCategories, selectProfileCurrency } from '../store/profile/profile.state';
import {
    selectShipmentEditorCurrency,
    selectShipmentEditorInsuranceAmount,
    selectShipmentEditorInsuranceCategory
} from '../store/shipment-editor/shipment-editor.state';
import { ConstraintEnum } from '../enum/constraint.enum';
import { CurrencyService } from '../modules/shared/services/currency.service';

@Injectable({ providedIn: 'root' })
export class ShipmentInsuranceValidator implements StateValidator {

    constructor(private store: Store<AppState>, private currencyService: CurrencyService) {}

    insuranceCategories = this.store.selectSignal(selectInsuranceCategories);
    selectedInsuranceCategory = this.store.selectSignal(selectShipmentEditorInsuranceCategory);
    insuranceAmount = this.store.selectSignal(selectShipmentEditorInsuranceAmount);
    profileCurrency = this.store.selectSignal(selectProfileCurrency);
    shipmentCurrency = this.store.selectSignal(selectShipmentEditorCurrency);
    category = computed(
        () => this.insuranceCategories().find(c => c.id === this.selectedInsuranceCategory())
    );

    supports(constraintType: ConstraintTypeEnum): boolean {
        return constraintType === ConstraintTypeEnum.SHIPMENT;
    }

    validate(state: any, constraintType: ConstraintTypeEnum, mode: ValidationMode): Violation[] {
        const category = this.category();
        if (mode === ValidationMode.NONE) {
            return [];
        }
        if (!category) {
            return [];
        }
        if (!category.allowed) {
            return [{
                id: ConstraintEnum.INSURANCE_CATEGORY_DISABLED,
                path: 'shipment.insurance',
                message: $localize`We cannot insure contents in the "${category.caption}" category`
            }];
        }
        const insuranceAmount = this.currencyService.from(this.insuranceAmount(), this.shipmentCurrency());
        if (insuranceAmount > category.maximumValue) {
            const limit = this.currencyService.render(category.maximumValue, this.profileCurrency());
            return [{
                id: ConstraintEnum.INSURANCE_ABOVE_LIMIT,
                path: 'shipment.insurance',
                message: $localize`Insurance amount cannot exceed ${limit}`
            }];
        }
        return [];
    }
}
